import { Payments } from '@or-sdk/payments';

import { useAuthStore } from '@/stores/auth/auth';

import config from '../config';


export default new Payments({
  paymentsUrl: config.PAYMENTS_API_URL,
  token: () => useAuthStore().reactiveToken as string,
});
